<div class="skeleton-wrapper">

  <!-- Header -->
  <div class="skeleton-row header wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>

  <!-- Body rows -->
  <div class="skeleton-row  wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>

  <div class="skeleton-row  wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>

  <div class="skeleton-row  wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>
  <div class="skeleton-row  wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>
  <div class="skeleton-row  wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>
  <div class="skeleton-row  wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>
  <div class="skeleton-row  wccard p-3">
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
    <div class="skeleton-box"></div>
  </div>

</div>
